import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Brand, BrandSimple} from '../models/brand.model';
import {map} from 'rxjs/operators';
import {SearchQueryParams} from '../models/search-query-params.model';
import {mapSearchListResponse} from '../helpers/search.helper';

@Injectable()
export class BrandsService {
    baseUrl = '/api/secured/brand';

    constructor(
        private http: HttpClient,
    ) {
    }

    fetchList(props: SearchQueryParams) {
        return this.http
            .get<Brand[]>(`${this.baseUrl}/admin`, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<Brand>(Brand));
    }

    add(brand: Brand) {
        return this.http.post(`${this.baseUrl}/admin`, {...brand});
    }

    delete(brand: Brand) {
        if (brand.modelCode === null) {
            return this.http.delete(`${this.baseUrl}/admin/${brand.brandId}`);
        } else {
            return this.http.delete(`${this.baseUrl}/admin/model/${brand.modelId}`);
        }
    }

    getFieldList(brand: string) {
        return this.http
            .get<BrandSimple[]>(`${this.baseUrl}/${brand}/models`, {observe: 'response'})
            .pipe((map(response => response.body)));
    }

    getFilteredBrandsList(search: string) {
        return this.http
            .get<Brand[]>(`${this.baseUrl}/admin`, {params: {search}, observe: 'response'})
            .pipe((map(response => response.body)));
    }

    brandsSearchList(codeSearch) {
        return this.http.get<BrandSimple[]>(this.baseUrl, {params: {codeSearch}});
    }

    modelSearchList(codeSearch, brand) {
        return this.http.get<BrandSimple[]>(`${this.baseUrl}/${brand}/models`, {params: {codeSearch}});
    }
}
